// =============================================================================
// Scope choosers for repeating events — "only this one / this and all
// following / the whole series". One for editing (primary buttons, i18n
// keys) and one for deleting (red buttons). Calendar.js supplies the
// handlers that finish the edit or delete.
// =============================================================================

import React from 'react';
import { useTranslation } from '../../lib/i18n';

export const RecurringEditScopeModal = ({ onOnlyThis, onThisAndFuture, onAll, onCancel }) => {
  const { t } = useTranslation();
  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-xl w-full max-w-sm overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 pt-5 pb-3 text-center">
          <p className="text-sm text-gray-700">
            {t('calendar.editSeriesPrompt', 'Dieser Termin wiederholt sich. Was möchtest du ändern?')}
          </p>
        </div>
        <div className="border-t border-gray-200 divide-y divide-gray-200">
          <button
            onClick={onOnlyThis}
            className="w-full px-5 py-3 text-primary-600 font-medium hover:bg-gray-50"
          >
            {t('calendar.editOnlyThis', 'Nur diesen Termin')}
          </button>
          <button
            onClick={onThisAndFuture}
            className="w-full px-5 py-3 text-primary-600 font-medium hover:bg-gray-50"
          >
            {t('calendar.editThisAndFuture', 'Diesen und alle zukünftigen')}
          </button>
          <button
            onClick={onAll}
            className="w-full px-5 py-3 text-primary-600 font-medium hover:bg-gray-50"
          >
            {t('calendar.editAll', 'Alle Termine der Serie')}
          </button>
          <button
            onClick={onCancel}
            className="w-full px-5 py-3 text-gray-600 font-medium hover:bg-gray-50"
          >
            {t('common.cancel', 'Abbrechen')}
          </button>
        </div>
      </div>
    </div>
  );
};

export const RecurringDeleteScopeModal = ({ onOnlyThis, onThisAndFuture, onAll, onCancel }) => {
  const { t } = useTranslation();
  return (
  <div
    className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4"
    onClick={onCancel}
  >
    <div
      className="bg-white rounded-xl w-full max-w-sm overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="px-5 pt-5 pb-3 text-center">
        <p className="text-sm text-gray-700">
          {t('calendar.deleteSeriesPrompt')}
        </p>
      </div>
      <div className="border-t border-gray-200 divide-y divide-gray-200">
        <button
          onClick={onOnlyThis}
          className="w-full px-5 py-3 text-red-600 font-medium hover:bg-gray-50"
        >
          {t('calendar.deleteOnlyThis')}
        </button>
        <button
          onClick={onThisAndFuture}
          className="w-full px-5 py-3 text-red-600 font-medium hover:bg-gray-50"
        >
          {t('calendar.deleteThisAndFuture')}
        </button>
        <button
          onClick={onAll}
          className="w-full px-5 py-3 text-red-600 font-medium hover:bg-gray-50"
        >
          {t('calendar.deleteAll')}
        </button>
        <button
          onClick={onCancel}
          className="w-full px-5 py-3 text-gray-600 font-medium hover:bg-gray-50"
        >
          {t('common.cancel')}
        </button>
      </div>
    </div>
  </div>
  );
};
